import React, { useCallback, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import translate from '../../../../commonComponents/translate';
import FormSubtitle from '../../../../commonComponents/forms/FormSubtitle';
import SignedDocumentsListItem from '../../../../commonComponents/signedDocuments/SignedDocumentsListItem';
import Notifications from '../../../../services/notifications';
import withCSRF from '../../../../commonComponents/withCSRF';
import { compose } from '../../../../services/utilityFunctions';
import LoggedUserContext from '../../../../contextProviders/LoggedUserContext';

function DocumentsPanel({ t, _csrf }) {
  const { loggedUser } = useContext(LoggedUserContext);
  const [documents, setDocuments] = useState([]);

  const getDocuments = useCallback(async () => {
    try {
      const { data: response } = await axios.get('/api/journey/documents/signed/list', {
        params: {
          user: loggedUser._id,
          populate: ['journey'],
        },
        headers: {
          'Accept-Version': '1.0.0',
          'X-Gamification-API': 'Games',
          'X-CSRF-Token': _csrf,
          _csrf,
        },
      });

      setDocuments(response.data);
    } catch (err) {
      Notifications.showErrorFromRequest(err);
    }
  }, [setDocuments]);

  useEffect(() => {
    getDocuments();
  }, []);

  return (
    <div className="m-portlet__body">
      <FormSubtitle
        title={t('uploaded.documents')}
        titleClass="title-signed-section"
      />
      <div className="profile-signed-document-grid">
        {documents.length > 0 ? (
          documents.map(document => (
            <SignedDocumentsListItem
              key={document._id}
              file={document}
              size="small"
            />
          ))
        ) : (
          <p className="no-data-hint">{t('report.documents.notFound')}</p>
        )}
      </div>
    </div>
  );
}

DocumentsPanel.propTypes = {
  /** translation function */
  t: PropTypes.func.isRequired,
  /** user signed documents */
  _csrf: PropTypes.string.isRequired,
};

DocumentsPanel.defaultProps = {
};

export default compose(translate, withCSRF)(DocumentsPanel);
